<h3 mat-dialog-title i18n>Confirm delete order</h3>
<mat-dialog-content>
  Are you sure you want to delete order {{data.order.orderNr}}?
  
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="basic" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="confirm()">Delete</button>

</mat-dialog-actions>



// WEBPACK FOOTER //
// ./src/app/order/components/delete-order-dialog/delete-order-dialog.component.html